// extracted by mini-css-extract-plugin
export default {"labelClass":"LoanContracts_labelClass__LsgBT","list":"LoanContracts_list__cX+rS","totalBlock":"LoanContracts_totalBlock__IGMoU"};